import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/auth.jsx'
import { api } from '../lib/api.js'

function NavLink({ to, children }) {
  const loc = useLocation()
  const active = loc.pathname === to
  return (
    <Link
      to={to}
      className={
        'px-3 py-2 rounded-xl text-sm border transition ' +
        (active ? 'border-white/25 bg-white/10 text-white' : 'border-transparent text-white/70 hover:text-white hover:bg-white/5')
      }
    >
      {children}
    </Link>
  )
}

export default function Navbar({ onOpenAuth }) {
  const { user, token, logout } = useAuth()
  const [site, setSite] = React.useState(null)

  React.useEffect(() => {
    let live = true
    api('/api/site').then((d) => { if (live) setSite(d.site || null) }).catch(() => {})
    return () => { live = false }
  }, [])

  const brand = site?.brand?.name || 'DeltaReloaded'
  const isAdmin = user?.role === 'admin'

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur">
      <div className="mx-auto max-w-6xl px-4 py-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <Link to="/" className="font-semibold text-white tracking-wide">{brand}</Link>
          <nav className="hidden md:flex items-center">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/media">Media</NavLink>
            <NavLink to="/roadmap">Roadmap</NavLink>
            <NavLink to="/news">News</NavLink>
            <NavLink to="/launcher">Launcher</NavLink>
            {isAdmin ? <NavLink to="/admin">Admin</NavLink> : null}
          </nav>
        </div>

        <div className="flex items-center gap-2">
          <Link to="/account" className="hidden sm:inline-flex rounded-xl border border-white/10 bg-black/20 px-4 py-2 text-sm text-white/70 hover:bg-white/5">
            {user ? user.handle : 'Account'}
          </Link>
          {!user ? (
            <>
              <button
                onClick={() => onOpenAuth?.('login')}
                className="rounded-xl border border-white/10 bg-black/20 px-4 py-2 text-sm text-white/70 hover:bg-white/5"
              >
                Login
              </button>
              <button
                onClick={() => onOpenAuth?.('register')}
                className="rounded-xl border border-white/15 bg-white/10 px-4 py-2 text-sm text-white hover:bg-white/15"
              >
                Register
              </button>
            </>
          ) : (
            <button
              onClick={logout}
              className="rounded-xl border border-white/10 bg-black/20 px-4 py-2 text-sm text-white/70 hover:bg-white/5"
            >
              Logout
            </button>
          )}
        </div>
      </div>

      {/* Mobile nav */}
      <div className="md:hidden border-t border-white/10">
        <div className="mx-auto max-w-6xl px-4 py-3 flex flex-wrap gap-2">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/media">Media</NavLink>
          <NavLink to="/roadmap">Roadmap</NavLink>
          <NavLink to="/news">News</NavLink>
          <NavLink to="/launcher">Launcher</NavLink>
          {isAdmin ? <NavLink to="/admin">Admin</NavLink> : null}
          <NavLink to="/account">Account</NavLink>
        </div>
      </div>
    </header>
  )
}
